const OsmCalculator = function() {
  // function for merging together the routes
	this.glue = function(routes) {
		var firstRoute = routes[0].childNodes[0];
		var totalDist = parseFloat(firstRoute.querySelectorAll('featureMember:last-child')[0].getElementsByTagName('TotalDist')[0].textContent);
		var totalTime = parseFloat(firstRoute.querySelectorAll('featureMember:last-child')[0].getElementsByTagName('TotalTime')[0].textContent);

		for(var i = 1; i < routes.length; i++) {
			var nextRoute = routes[i].childNodes[0];

			// add the time and dist of this route
			totalDist += parseFloat(nextRoute.querySelectorAll('featureMember:last-child')[0].getElementsByTagName('TotalDist')[0].textContent);
			totalTime += parseFloat(nextRoute.querySelectorAll('featureMember:last-child')[0].getElementsByTagName('TotalTime')[0].textContent);

			nextRoute = nextRoute.querySelectorAll('featureMember');

			// add all parts of this route to the main route
			for(var a = 1; a < nextRoute.length - 1; a++) {
				var ibm = firstRoute.querySelectorAll('featureMember:last-child')[0];
				var routePiece = nextRoute[a].cloneNode(true)
				firstRoute.insertBefore(routePiece, ibm);
			}
		}

		// set the total time and distance
		if(firstRoute.querySelectorAll('featureMember:last-child')[0] != undefined) {
			firstRoute.querySelectorAll('featureMember:last-child')[0].getElementsByTagName('TotalDist')[0].innerHTML = totalDist;
			firstRoute.querySelectorAll('featureMember:last-child')[0].getElementsByTagName('TotalTime')[0].innerHTML = totalTime;
		}

		return firstRoute;
	};
};

export default OsmCalculator;
